div
<template>
  <div>
    <div class="d-flex ngos-search-engine align-items-center">
      <form-autocomplete
        id="search_engine_temp"
        class="w-100"
        ep="v2/ministry/search-engine/ngos"
        :getOptionLabel="(x) => x.name_ar"
        @input="handleSelect"
        ref="serchEngineRef"
        @search="ngoName = $event"
        placeholder="ابدأ بالكتابة لعرض الاقتراحات ..."
      >
        <template #open-indicator="{ attributes }">
          <span> </span>
        </template>
        <template #search="{ attributes, events }">
          <input
            class="vs__search"
            v-bind="attributes"
            v-on="events"
            @keydown="handleSearchEnter"
          />
        </template>
      </form-autocomplete>

      <b-button
        style="margin-bottom: 15px"
        variant="primary"
        class="btn-icon mx-1"
        @mousedown="handleSearchClick"
      >
        <b-spinner style="width: 23px; height: 23px" size="sm" v-if="loading" />
        <feather-icon v-else size="23" icon="SearchIcon" />
      </b-button>
    </div>

    <div class="d-flex align-items-center">
      <small class="mr-50"> آخر عمليات البحث : </small>
      <b-badge
        @click="fetchSearchResults(tag)"
        class="mx-25 search-tag"
        v-for="(tag, i) in searchTags"
        :key="i"
        pill
        variant="light-secondary"
        >{{ tag }}</b-badge
      >
    </div>
  </div>
</template>

<script>
import FormInput from "@/components/form-input";
import {
  BListGroup,
  BButton,
  BBadge,
  BListGroupItem,
  BSpinner,
} from "bootstrap-vue";
import FormAutocomplete from "@/components/form-autocomplete/index.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  components: {
    FormInput,
    BListGroup,
    BListGroupItem,
    BSpinner,
    FormAutocomplete,
    FeatherIcon,
    BButton,
    BBadge,
  },
  props: {
    value: String,
  },
  data() {
    return {
      ngoName: "",
    };
  },
  methods: {
    ...mapMutations("Ministry/NgosSearch", ["setData", "pushSearchTag"]),
    ...mapActions("Ministry/NgosSearch", ["fetchSearchResults"]),
    handleSearchEnter(e) {
      if (e.keyCode === 13) this.fetchSearchResults(this.ngoName);
    },
    handleSearchClick(e) {
      this.fetchSearchResults(this.ngoName);
    },
    handleSelect(e) {
      this.setData([e]);
      this.pushSearchTag(e.name_ar);
    },
  },

  computed: {
    ...mapGetters("Ministry/NgosSearch", ["ngos", "loading", "searchTags"]),
  },
};
</script>

<style lang="scss">
.ngos-search-engine {
  .v-select {
    background: white !important;
  }
  .vs__search {
    padding: 5px !important;
  }
}
.search-tag {
  cursor: pointer;
  padding: 8px;
  &:hover {
    opacity: 0.8;
  }
}
</style>
